import { createContext, useContext } from 'react';

type SystemType = 'app' | 'page';

const RouterSystemContext = createContext<SystemType>('app');

export const useRouterSystem = (): SystemType => {
  const context = useContext(RouterSystemContext);
  if (!context) {
    return 'app';
  }
  return context;
};

interface RouterSystemProviderProps {
  routerType?: SystemType;
  children: React.ReactNode;
}

export const RouterSystemProvider = ({ routerType = 'page', children }: RouterSystemProviderProps) => {
  return <RouterSystemContext.Provider value={routerType}>{children}</RouterSystemContext.Provider>;
};
